import { loadIcons } from '@iconify/react';

// icons to be preloaded to prevent rendering delays
const icons = [
	'eva:cloud-download-outline',
	'eva:edit-fill',
	'eva:file-text-outline',
	'eva:trash-2-outline',
	'eva:move-fill',
];

export const preloadIconsAsync = () => {
	return new Promise((fulfill, reject) => {
		loadIcons(icons, (loaded, missing, pending) => {
			if (pending.length) {
				// Icons are pending, wait for all to load/fail
				//
				// If pending list is not empty, callback will be called
				// again when all icons are either loaded or missing
				return;
			}
			if (missing.length) {
				// eslint-disable-next-line prefer-promise-reject-errors
				reject({
					loaded,
					missing,
				});
			} else {
				fulfill({
					loaded,
				});
			}
		});
	});
};
